var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEapDeviceCeilingMountSquare2Ports(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18499_8709)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.2115 83.0231C1.2115 91.0941 7.75093 97.6507 15.8392 97.6507H83.1608C87.0328 97.6507 97.7368 95.6029 97.7885 83.0231C97.7885 83.0231 97.7368 29.3482 97.7885 15.7014C97.8229 4.99743 88.7021 1.1254 83.1608 1.07378C77 1.02215 19.5735 1.10819 15.8392 1.07378C10.7453 1.02215 1.28034 4.46395 1.2115 15.7014C1.14267 25.9924 1.2115 83.0231 1.2115 83.0231Z",
    fill: "white",
    stroke: "black",
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8219 2.05475H83.1436C90.6811 2.05475 96.8075 8.16395 96.8075 15.7187V75.2275C96.8075 82.765 90.6983 88.8914 83.1436 88.8914H15.8219C8.28437 88.8914 2.15796 82.7822 2.15796 75.2275V15.7187C2.17517 8.16395 8.28437 2.05475 15.8219 2.05475Z",
    stroke: "black",
    strokeWidth: 0.3,
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1403 75.2274C94.1747 55.3854 94.1747 35.5434 94.1403 15.7187C93.9165 9.57504 89.2873 4.94582 83.1437 4.7221C60.7032 4.68768 38.2626 4.68768 15.8221 4.7221C9.67844 4.94582 5.04921 9.57504 4.8255 15.7187C4.79108 35.5606 4.79108 55.4026 4.8255 75.2274C5.04921 81.371 9.67844 86.0003 15.8221 86.224C38.2626 86.2584 60.7032 86.2584 83.1437 86.224C89.2873 86.0003 93.9165 81.371 94.1403 75.2274Z",
    stroke: "black",
    strokeWidth: 0.5,
    strokeMiterlimit: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4828 95.3276C49.1558 95.3276 48.8977 95.0695 48.8977 94.7425V91.077V91.0253C48.8977 90.6984 49.1558 90.4402 49.4828 90.4402C49.8098 90.4402 50.0679 90.6984 50.0679 91.0253V91.077V94.7425C50.0679 95.0695 49.8098 95.3276 49.4828 95.3276Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18499_8709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 99,
    height: 99,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEapDeviceCeilingMountSquare2Ports);
export default __webpack_public_path__ + "static/media/eap-device-ceiling-mount-square-2-ports.8ffce79ac27fc935f78661e529fd1781.svg";
export { ForwardRef as ReactComponent };